/** Node alarm UI multi-select values (temperature, plus CO2 / humidity on new hardware; no-node / no-AP are AP-only). */
export const NODE_ALERT_TYPE_VALUES = [
    "lowTemperature",
    "highTemperature",
    "lowCo2",
    "highCo2",
    "lowHumidity",
    "highHumidity",
];
const NO_SENSOR_CHOICES = { co2: false, humidity: false };
export function booleansToNodeAlertTypes(r, sensors = NO_SENSOR_CHOICES) {
    const out = [];
    if (r.allowLowTemp)
        out.push("lowTemperature");
    if (r.allowHighTemp)
        out.push("highTemperature");
    if (sensors.co2) {
        if (r.allowLowCo2)
            out.push("lowCo2");
        if (r.allowHighCo2)
            out.push("highCo2");
    }
    if (sensors.humidity) {
        if (r.allowLowHumidity)
            out.push("lowHumidity");
        if (r.allowHighHumidity)
            out.push("highHumidity");
    }
    return out;
}
export function nodeAlertTypesToBooleans(types, sensors = NO_SENSOR_CHOICES) {
    return Object.assign(Object.assign({ allowLowTemp: types.includes("lowTemperature"), allowHighTemp: types.includes("highTemperature") }, (sensors.co2 && {
        allowLowCo2: types.includes("lowCo2"),
        allowHighCo2: types.includes("highCo2"),
    })), (sensors.humidity && {
        allowLowHumidity: types.includes("lowHumidity"),
        allowHighHumidity: types.includes("highHumidity"),
    }));
}
